import React from "react";
import TabTemplate from "../../../_shoru_shared_library/template/TabTemplate";
import dataAndAccountsRouter from "./dataAndAccountsTabRouter";

export default function DataAndAccountsTab(props) {

  return (
    <TabTemplate 
      router={dataAndAccountsRouter}
      passData={props.passData}
    />
  )

}